/** Cross-tab activity broadcast cadence — not used for local idle detection. */
export const ACTIVITY_BROADCAST_DEBOUNCE_MS = 30_000;

/** Sample mousemove for idle extension without firing on every pointer event. */
export const MOUSEMOVE_SAMPLE_MS = 1_000;

export function shouldSampleMousemove(
  lastMousemoveAt: number | null,
  now: number,
  sampleMs = MOUSEMOVE_SAMPLE_MS,
): boolean {
  return lastMousemoveAt === null || now - lastMousemoveAt >= sampleMs;
}

export function shouldBroadcastActivity(
  lastBroadcastAt: number | null,
  now: number,
  debounceMs = ACTIVITY_BROADCAST_DEBOUNCE_MS,
): boolean {
  return lastBroadcastAt === null || now - lastBroadcastAt >= debounceMs;
}
